import { render, staticRenderFns } from "./MenusIndex.vue?vue&type=template&id=53b45843&scoped=true&"
import script from "./MenusIndex.vue?vue&type=script&lang=js&"
export * from "./MenusIndex.vue?vue&type=script&lang=js&"
import style0 from "./MenusIndex.vue?vue&type=style&index=0&id=53b45843&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b45843",
  null
  
)

export default component.exports